import { Check } from 'lucide-react';

const WaitingHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="mx-auto h-16 w-16 bg-[#EEF5EF] rounded-full flex items-center justify-center mb-6">
        <Check className="h-8 w-8 text-[#288344]" strokeWidth={2.5} />
      </div>
      <h1 className="text-[28px] font-bold text-[#1A1A1A] tracking-tight mb-2">
        Application received
      </h1>
      <p className="text-[17px] text-[#4A4A4A]">
        We'll review and approve your account within 24–48 hours.
      </p>
    </div>
  );
};

export default WaitingHeader;
